import React from 'react';

export function Icon({name, className}) {

    return (
        <img alt='icon' className={'icon ' + (className || '')} src={name}/>
    );
}
